import { getStore } from '../store/Store';
import isWin32StylingEnabled from 'owa-theme-win32-style-store/lib/selectors/isWin32StylingEnabled';

export function shouldShowFolderPaneAsTransientOverlay(): boolean {
    return isWin32StylingEnabled() && getStore().showFolderPaneAsTransientOverlay;
}
